const buttonClass = []
const forms = document.querySelector('.forms')
const filterButton = forms.querySelectorAll('.action')
const form = forms.querySelectorAll('.form')

const areAnyCheckboxesChecked = () => {
	return Array.from(filterButton).some(label => {
		let radio = label.querySelector('input[type="radio"]')
		return radio.checked
	})
}

filterButton.forEach(b => {
	b.addEventListener('change', e => {
		form.forEach(file => {
			file.classList.remove('active')
		})
		if (!areAnyCheckboxesChecked()) {
			form.forEach(file => {
				file.classList.add('active')
			})
		} else {
			filterButton.forEach(label => {
				let radio = label.querySelector('input[type="radio"]')
				if (radio.checked) {
					const category = label.dataset.category
					form.forEach(file => {
						if (file.classList.contains(category)) {
							file.classList.add('active')
						}
					})
				}
			})
		}
	})
})
